module.exports = __webpack_public_path__ + "img/ch-banner.a661e3df.png";